import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// actions
import { change } from 'redux-form/immutable';

// components
import ScheduleSegment from './_ScheduleSegment';
import { FormSection } from 'redux-form/immutable';

class ScheduleForm extends React.Component {
  static propTypes = {
    form: PropTypes.string.isRequired,
    formValues: PropTypes.instanceOf(Immutable.Map),
  };

  render() {
    return (
      <div className="schedule">
        <div className="schedule__segment">
          <p className="schedule__segment__label">Breakfast</p>
          {this._renderScheduleSegments('segment1', 25200, 42400)}
        </div>
        <div className="schedule__segment">
          <p className="schedule__segment__label">Lunch</p>
          {this._renderScheduleSegments('segment2', 37800, 50400)}
        </div>
        <div className="schedule__segment">
          <p className="schedule__segment__label">Snack</p>
          {this._renderScheduleSegments('segment3', 46800, 64800)}
        </div>
      </div>
    );
  }

  // private

  _handleDisable = this._handleDisable.bind(this);

  _handleDisable() {
    ScheduleForm.validate(this.props);
  }

  _renderScheduleSegments(segment, startTime, endTime) {
    const components = [];
    const form = this.props.form;
    // Ensure formValues is always an Immutable.Map
    const formValues = Immutable.Map.isMap(this.props.formValues)
      ? this.props.formValues
      : Immutable.Map(this.props.formValues || {});
    const ids = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'];
    const labels = [
      'Mondays',
      'Tuesdays',
      'Wednesdays',
      'Thursdays',
      'Fridays',
    ];

    for (let i = 0; i < 5; i++) {
      const id = ids[i];
      const label = labels[i];
      const name = `${segment}.${id}`;

      const disabled = !(
        formValues.getIn(['office', 'schedule', segment, id, 'enabled']) ||
        false
      );
      const from = formValues.getIn([
        'office',
        'schedule',
        segment,
        id,
        'from',
      ]);
      const to = formValues.getIn(['office', 'schedule', segment, id, 'to']);
      const hasError = formValues.getIn([
        'office',
        'schedule',
        segment,
        id,
        'hasError',
      ]);

      components.push(
        <FormSection key={id} name={name}>
          <ScheduleSegment
            disabled={disabled}
            endTime={endTime}
            form={form}
            fromValue={from}
            hasError={hasError}
            label={label}
            name={`office.schedule.${name}`}
            onDisable={this._handleDisable}
            startTime={startTime}
            toValue={to}
          />
        </FormSection>,
      );
    }

    return components;
  }
}

ScheduleForm.validate = function ({
  dispatch,
  form,
  formValues = Immutable.Map(),
}) {
  // Ensure formValues is always an Immutable.Map
  const safeFormValues = Immutable.Map.isMap(formValues)
    ? formValues
    : Immutable.Map(formValues || {});
  const schedule =
    safeFormValues.getIn(['office', 'schedule']) || Immutable.List();

  let hasError = false;

  schedule.forEach((segment, segmentKey) => {
    segment.forEach((period, periodKey) => {
      const enabled = period.get('enabled');
      const from = period.get('from');
      const to = period.get('to');

      if (enabled && (!from || !to)) {
        hasError = true;

        dispatch(
          change(
            form,
            `office.schedule.${segmentKey}.${periodKey}.hasError`,
            true,
          ),
        );
      } else {
        dispatch(
          change(
            form,
            `office.schedule.${segmentKey}.${periodKey}.hasError`,
            false,
          ),
        );
      }
    });
  });

  return !hasError;
};

export default connect()(ScheduleForm);



// WEBPACK FOOTER //
// ./app/components/managers/_ScheduleForm.jsx